<template>
  <v-card flat class="pa-4 chart-wrapper" width="100%" v-if="radialSeries.length > 0">
    <apexchart width="100%" type="radialBar" :options="radialOptions" :series="radialSeries"/>
  </v-card>
</template>

<script>
export default {
  name: "operationChart",

  data: () => ({
    radialOptions: {
      chart: {
        height: 350,
        type: 'radialBar',
      },
      plotOptions: {
        radialBar: {
          offsetY: 0,
          startAngle: 0,
          endAngle: 270,
          hollow: {
            margin: 0,
            size: '40%',
            background: 'transparent',
            image: undefined,
          },
          dataLabels: {
            name: {
              show: false,
            },
            value: {
              show: false,
            }
          }
        }
      },
      colors: ['#1065BE', '#F00239', '#007851', '#E78A00'],
      // colors: ['#006363', '#F23030', '#27C127', '#F2B130'],
      labels: [],
      legend: {
        show: true,
        floating: true,
        fontSize: '14px',
        offsetX: 130,
        offsetY: 9,
        labels: {
          colors: '#fff'
        },
        markers: {
          width: 5,
          offsetX: 5
        },
        formatter: function (seriesName, opts) {
          return seriesName + ": " + opts.w.globals.series[opts.seriesIndex].toFixed(1) + "%"
        },
        itemMargin: {
          vertical: 3
        }
      },
      responsive: [{
        breakpoint: 1904,
        options: {
          chart: {
            height: 350
          },
          legend: {
            fontSize: '12px',
            position: 'left',
            offsetX: 20,
            offsetY: 8,
            markers: {
              width: 6,
              height: 10
            },
            itemMargin: {
              vertical: -1
            }
          }
        }
      }, {
        breakpoint: 1264,
        options: {
          chart: {
            height: 250
          },
          legend: {
            fontSize: '10px',
            position: 'left',
            offsetX: -2,
            offsetY: 2,
            markers: {
              width: 5,
              height: 8
            },
            itemMargin: {
              vertical: -2
            }
          }
        }
      }, {
        breakpoint: 960,
        options: {
          chart: {
            height: 300
          },
          legend: {
            fontSize: '14px',
            position: 'left',
            offsetX: 220,
            offsetY: 8,
            markers: {
              width: 5,
              height: 10
            },
            itemMargin: {
              vertical: 0
            }
          }
        }
      }, {
        breakpoint: 845,
        options: {
          legend: {
            offsetX: 120,
          }
        }
      }, {
        breakpoint: 600,
        options: {
          legend: {
            fontSize: '10px',
            offsetX: 50,
          }
        }
      }, {
        breakpoint: 340,
        options: {
          legend: {
            offsetX: -8,
            offsetY: 3,
            itemMargin: {
              vertical: -1
            }
          }
        }
      }]
    },
    radialSeries: [],
  }),

  methods: {
    updateData(obj) {
      if (obj) {
        this.radialOptions.labels = Object.keys(obj)
        this.radialSeries = Object.values(obj)
      }
    }
  }
}
</script>

<style scoped>

</style>